import { Update } from 'src/shared/types/update';

/**
 * The cloaks of the suppliers an update links, in order and without blanks.
 *
 * An update used to carry a single `cloak` string; it now links a set of
 * suppliers, of which a client is only ever shown the cloak - the name and id
 * never leave the backend (`backend/updates/serializers.py >
 * SupplierAtUpdateSerializer`).
 */
export const updateSupplierCloaks = (update?: Update | null): string[] =>
  (update?.entities?.suppliers ?? [])
    .map((supplier) => supplier.cloak)
    .filter((cloak): cloak is string => Boolean(cloak));

/** The cloaks joined for display, or `null` when the update names no supplier. */
export const updateSupplierCloakLabel = (
  update?: Update | null
): string | null => {
  const cloaks = updateSupplierCloaks(update);

  return cloaks.length > 0 ? cloaks.join(', ') : null;
};
